import { cn } from '@forest/shared'
import { m } from '~/paraglide/messages'

export function PlusBadge(props: { class?: string }) {
  return (
    <svg
      viewBox="0 0 33 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={m.plus()}
      class={cn('h-[15px] shrink-0', props.class)}
    >
      <g filter="url(#plus-badge-inner-shadow)">
        <rect
          width="32.8936"
          height="15"
          rx="5.44681"
          fill="url(#plus-badge-gradient)"
        />
        <rect
          x="0.510638"
          y="0.510638"
          width="31.8723"
          height="13.9787"
          rx="4.93617"
          stroke="white"
          stroke-width="1.02128"
        />
        <path
          d="M7.24374 9.92647H5.9365V4.75472H8.2405C8.75795 4.75472 9.17191 4.81736 9.48237 4.94264C9.79284 5.06791 10.0162 5.27217 10.1523 5.5554C10.2885 5.83864 10.3566 6.22264 10.3566 6.7074C10.3566 7.16494 10.2885 7.53804 10.1523 7.82672C10.0162 8.10996 9.79284 8.31966 9.48237 8.45583C9.17191 8.592 8.75795 8.66009 8.2405 8.66009H7.24374V9.92647ZM8.02808 5.82502H7.24374V7.58979H8.02808C8.4148 7.58979 8.67352 7.52443 8.80425 7.3937C8.93497 7.26298 9.00033 7.03421 9.00033 6.7074C9.00033 6.39694 8.93497 6.17362 8.80425 6.03745C8.67352 5.89583 8.4148 5.82502 8.02808 5.82502ZM15.2994 8.81532V9.92647H11.5411V4.75472H12.8483V8.81532H15.2994ZM20.841 4.75472V7.80221C20.841 8.336 20.7757 8.76357 20.6449 9.08494C20.5197 9.4063 20.2991 9.64051 19.9831 9.78757C19.6672 9.92919 19.2206 10 18.6432 10C18.0441 10 17.5784 9.92919 17.2461 9.78757C16.9193 9.64051 16.6905 9.4063 16.5598 9.08494C16.4291 8.76357 16.3637 8.336 16.3637 7.80221V4.75472H17.671V7.7777C17.671 8.05549 17.6982 8.27336 17.7527 8.43132C17.8071 8.58928 17.9052 8.70094 18.0468 8.7663C18.1884 8.82621 18.3872 8.85617 18.6432 8.85617C18.8829 8.85617 19.0654 8.82621 19.1906 8.7663C19.3214 8.70094 19.4112 8.58928 19.4602 8.43132C19.5093 8.27336 19.5338 8.05549 19.5338 7.7777V4.75472H20.841ZM22.1807 8.59472C22.4203 8.67643 22.6818 8.74179 22.965 8.79081C23.2537 8.83438 23.5397 8.85617 23.8229 8.85617C24.2096 8.85617 24.4956 8.83983 24.6808 8.80715C24.8714 8.76902 24.9967 8.71183 25.0566 8.63557C25.1165 8.55932 25.1465 8.46128 25.1465 8.34145C25.1465 8.23796 25.1247 8.15626 25.0811 8.09634C25.0375 8.03643 24.9531 7.99013 24.8278 7.95745C24.7025 7.91932 24.5174 7.88936 24.2722 7.86757L23.733 7.81855C23.3299 7.78043 23.0113 7.696 22.7771 7.56528C22.5483 7.43455 22.3849 7.26026 22.2869 7.04238C22.1943 6.81906 22.148 6.55217 22.148 6.2417C22.148 5.87132 22.2215 5.57174 22.3686 5.34298C22.5211 5.11421 22.7662 4.94808 23.1039 4.8446C23.4416 4.73566 23.891 4.68119 24.452 4.68119C25.1819 4.68119 25.7837 4.77651 26.2576 4.96715L26.2331 6.0783L26.2086 6.11098C25.6694 5.92034 25.1056 5.82502 24.5174 5.82502C24.2341 5.82502 24.0162 5.84136 23.8637 5.87404C23.7112 5.90128 23.605 5.94757 23.5451 6.01294C23.4852 6.0783 23.4552 6.17089 23.4552 6.29072C23.4552 6.41055 23.4743 6.50043 23.5124 6.56034C23.556 6.62026 23.6404 6.66655 23.7657 6.69923C23.891 6.72647 24.0734 6.7537 24.3131 6.78094L24.8278 6.83813C25.2636 6.88715 25.5985 6.9743 25.8328 7.09957C26.067 7.22485 26.2277 7.3937 26.3148 7.60613C26.4074 7.81311 26.4537 8.06638 26.4537 8.36596C26.4537 8.73089 26.3747 9.03591 26.2168 9.28102C26.0642 9.52068 25.8137 9.70043 25.4651 9.82026C25.1165 9.94009 24.6508 10 24.068 10C23.6867 10 23.3436 9.98094 23.0385 9.94281C22.7335 9.89923 22.4367 9.84204 22.148 9.77123V8.61923L22.1807 8.59472Z"
          fill="white"
        />
      </g>
      <defs>
        <filter
          id="plus-badge-inner-shadow"
          x="0"
          y="-2.04255"
          width="32.8936"
          height="17.0426"
          filterUnits="userSpaceOnUse"
          color-interpolation-filters="sRGB"
        >
          <feFlood flood-opacity="0" result="BackgroundImageFix" />
          <feBlend
            mode="normal"
            in="SourceGraphic"
            in2="BackgroundImageFix"
            result="shape"
          />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="-2.04255" />
          <feGaussianBlur stdDeviation="2.62128" />
          <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 0.0473821 0 0 0 0.41 0"
          />
          <feBlend mode="normal" in2="shape" result="effect1_innerShadow" />
        </filter>
        <linearGradient
          id="plus-badge-gradient"
          x1="4.60511"
          y1="-1.36364"
          x2="25.6648"
          y2="17.3177"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#62F062" stop-opacity="0.89" />
          <stop offset="1" stop-color="#01B1E1" />
        </linearGradient>
      </defs>
    </svg>
  )
}
